import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import style from "./JForm.module.css";

const DonationForm = () => {
  const [formData, setFormData] = useState({
    annadaanSeva: false,
    tulsiarchanaSeva: false,
    vastraAlankarSeva: false,
    vaikunthaDwaraPujaSeva: false,
    ladduprasadaSeva: false,
    // mandirAlnkarnaSeva: false,
    donateByWish: false,

    selectedAnnadaanAmount: null,
    customAnnadaanAmount: "",
    selectedtulsiarchanaAmount: null,
    customtulsiarchanaAmount: "",
    selectedvastraAlankarAmount: null,
    customvastraAlankarAmount: "",
    selectedvaikunthaDwaraPujaAmount: null,
    customvaikunthaDwaraPujaAmount: "",
    selectedladduprasadaAmount: null,
    customladduprasadaAmount: "",
    selectedDonationAmount: null,
    customDonationAmount: "",
    // selectedMandirAlnkarnaAmount: false,
    // customMandirAlnkarnaAmount: "",

    sevaDate: "",
    honoureeName: "",
    relationship: "",
    donorName: "",
    email: "",
    mobile: "",
    dob: "",
    receive80G: false,
    panNumber: "",
    receiveMahaPrasadam: false,

    mahaPrasadamDetails: {
      doorNumber: "",
      houseName: "",
      streetName: "",
      area: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
    },
  });

  const [errors, setErrors] = useState({});
  const [show80GDetails, setShow80GDetails] = useState(false);
  const [showMahaPrasadamDetails, setShowMahaPrasadamDetails] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      };

      if (name === "customAnnadaanAmount" && value) {
        updatedData.selectedAnnadaanAmount = parseFloat(value);
      } else if (name === "customvastraAlankarAmount" && value) {
        updatedData.selectedvastraAlankarAmount = parseFloat(value);
      } else if (name === "customvaikunthaDwaraPujaAmount" && value) {
        updatedData.selectedvaikunthaDwaraPujaAmount = parseFloat(value);
      } else if (name === "customladduprasadaAmount" && value) {
        updatedData.selectedladduprasadaAmount = parseFloat(value);
      } else if (name === "customDonationAmount" && value) {
        updatedData.selectedDonationAmount = parseFloat(value);
      }

      return updatedData;
    });
  };

  const handle80GCheckboxChange = (e) => {
    setShow80GDetails(e.target.checked);
    handleInputChange(e);
  };

  const handleMahaPrasadamCheckboxChange = (e) => {
    setShowMahaPrasadamDetails(e.target.checked);
    handleInputChange(e);
  };
  const handleAmountSelect = (section, amount) => {
    setFormData((prevData) => {
      switch (section) {
        case "annadaan":
          return {
            ...prevData,
            selectedAnnadaanAmount:
              prevData.selectedAnnadaanAmount === amount ? null : amount,
            customAnnadaanAmount: "",
          };

        case "tulsiarchana":
          return {
            ...prevData,
            selectedtulsiarchanaAmount:
              prevData.selectedtulsiarchanaAmount === amount ? null : amount,
            customtulsiarchanaAmount: "",
          };
        case "vastraAlankar":
          return {
            ...prevData,
            selectedvastraAlankarAmount:
              prevData.selectedvastraAlankarAmount === amount ? null : amount,
            customvastraAlankarAmount: "",
          };
        case "vaikunthaDwaraPuja":
          return {
            ...prevData,
            selectedvaikunthaDwaraPujaAmount:
              prevData.selectedvaikunthaDwaraPujaAmount === amount
                ? null
                : amount,
            customvaikunthaDwaraPujaAmount: "",
          };
        case "ladduprasada":
          return {
            ...prevData,
            selectedladduprasadaAmount:
              prevData.selectedladduprasadaAmount === amount ? null : amount,
            customladduprasadaAmount: "",
          };
        default:
          return prevData;
      }
    });
  };

  // const validateForm = () => {
  //   const newErrors = {};

  //   if (!formData.donorName) newErrors.donorName = "Donor name is required";
  //   if (!formData.email) newErrors.email = "Email is required";
  //   if (!formData.mobile) newErrors.mobile = "Mobile number is required";
  //   if (!formData.dob) newErrors.dob = "Date of birth is required";
  //   if (formData.receive80G && !formData.panNumber)
  //     newErrors.panNumber = "PAN number is required for 80G certificate";

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const getTotalAmount = () => {
    const annadaanAmount =
      formData.selectedAnnadaanAmount ||
      parseFloat(formData.customAnnadaanAmount) ||
      0;

    const tulsiarchanaAmount =
      formData.selectedtulsiarchanaAmount ||
      parseFloat(formData.customtulsiarchanaAmount) ||
      0;
    const vastraAlankarAmount =
      formData.selectedvastraAlankarAmount ||
      parseFloat(formData.customvastraAlankarAmount) ||
      0;
    const vaikunthaDwaraPujaAmount =
      formData.selectedvaikunthaDwaraPujaAmount ||
      parseFloat(formData.customvaikunthaDwaraPujaAmount) ||
      0;
    const ladduprasadaAmount =
      formData.selectedladduprasadaAmount ||
      parseFloat(formData.customladduprasadaAmount) ||
      0;

    const donationByWishAmount =
      formData.selectedDonationAmount ||
      parseFloat(formData.customDonationAmount) ||
      0;

    return (
      annadaanAmount +
      tulsiarchanaAmount +
      vastraAlankarAmount +
      vaikunthaDwaraPujaAmount +
      ladduprasadaAmount +
      donationByWishAmount
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (!validateForm()) return;

    const totalAmount = getTotalAmount();
    let isFormDataStored = false;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        {
          amount: totalAmount,
          currency: "INR",
        }
      );

      const order = response.data;
      let sevaDescription = "Donation Payment";

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: totalAmount * 100,
        currency: "INR",
        name: "ISKCON Vaikunta Ekadashi Donation",
        description: sevaDescription,
        order_id: order.id,
        notes: {
          donationType: "Vaikunta Ekadashi Donation",
          meals: "Custom Amount",
          amount: totalAmount,
        },
        handler: async function (response) {
          try {
            const verificationResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: {
                  amount: totalAmount,
                  paymentStatus: "Successful",
                  submissionDate: new Date().toISOString(),
                },
              }
            );

            if (verificationResponse.data.success) {
              alert("Payment Successful!");
              if (!isFormDataStored) {
                await storeFormData("Payment Successful");
                isFormDataStored = true;
              }
            }
          } catch (err) {
            console.error(err);
            alert("Payment verification failed");
            if (!isFormDataStored) {
              await storeFormData("Payment Failed");
              isFormDataStored = true;
            }
          }
        },
        prefill: {
          name: formData.donorName,
          email: formData.email,
          contact: formData.mobile,
        },
        theme: { color: "#C61D21" },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
        if (!isFormDataStored) {
          await storeFormData("Payment Failed");
          isFormDataStored = true;
        }
      });
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Failed to initiate payment. Please try again.");
      if (!isFormDataStored) {
        await storeFormData("Payment Failed");
        isFormDataStored = true;
      }
    }
  };

  const storeFormData = async (paymentStatus) => {
    const totalDonationAmount = getTotalAmount();

    // Prepare data in the format expected by your Apps Script
    const formDataToSend = new URLSearchParams();

    // Add all fields to the form data
    formDataToSend.append("paymentStatus", paymentStatus);

    formDataToSend.append("annadaanSeva", formData.annadaanSeva ? "Yes" : "No");
    formDataToSend.append(
      "annadaanAmount",
      formData.selectedAnnadaanAmount || formData.customAnnadaanAmount || 0
    );
    formDataToSend.append(
      "tulsiarchanaSeva",
      formData.tulsiarchanaSeva ? "Yes" : "No"
    );

    formDataToSend.append(
      "tulsiarchanaAmount",
      formData.selectedtulsiarchanaAmount ||
        formData.customtulsiarchanaAmount ||
        0
    );
    formDataToSend.append(
      "vastraAlankarSeva",
      formData.vastraAlankarSeva ? "Yes" : "No"
    );
    formDataToSend.append(
      "vastraAlankarAmount",
      formData.selectedvastraAlankarAmount ||
        formData.customvastraAlankarAmount ||
        0
    );
    formDataToSend.append(
      "vaikunthaDwaraPujaSeva",
      formData.vaikunthaDwaraPujaSeva ? "Yes" : "No"
    );
    formDataToSend.append(
      "vaikunthaDwaraPujaAmount",
      formData.selectedvaikunthaDwaraPujaAmount ||
        formData.customvaikunthaDwaraPujaAmount ||
        0
    );
    formDataToSend.append(
      "ladduprasadaSeva",
      formData.ladduprasadaSeva ? "Yes" : "No"
    );
    formDataToSend.append(
      "ladduprasadaAmount",
      formData.selectedladduprasadaAmount ||
        formData.customladduprasadaAmount ||
        0
    );

    formDataToSend.append("donateByWish", formData.donateByWish ? "Yes" : "No");
    formDataToSend.append(
      "donationByWishAmount",
      formData.selectedDonationAmount || formData.customDonationAmount || 0
    );

    formDataToSend.append("totalDonationAmount", totalDonationAmount);
    formDataToSend.append("sevaDate", formData.sevaDate || "");
    formDataToSend.append("honoureeName", formData.honoureeName || "");
    formDataToSend.append("relationship", formData.relationship || "");
    formDataToSend.append("donorName", formData.donorName);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("mobile", formData.mobile);
    formDataToSend.append("dob", formData.dob);
    // formDataToSend.append("receive80G", formData.receive80G ? "Yes" : "No");
    // formDataToSend.append(
    //   "panNumber",
    //   formData.receive80G ? formData.panNumber : ""
    // );
    formDataToSend.append(
      "receiveMahaPrasadam",
      formData.receiveMahaPrasadam ? "Yes" : "No"
    );
    formDataToSend.append(
      "doorNumber",
      formData.mahaPrasadamDetails.doorNumber || ""
    );
    formDataToSend.append(
      "houseName",
      formData.mahaPrasadamDetails.houseName || ""
    );
    formDataToSend.append(
      "streetName",
      formData.mahaPrasadamDetails.streetName || ""
    );
    formDataToSend.append("area", formData.mahaPrasadamDetails.area || "");
    formDataToSend.append(
      "country",
      formData.mahaPrasadamDetails.country || ""
    );
    formDataToSend.append("state", formData.mahaPrasadamDetails.state || "");
    formDataToSend.append("city", formData.mahaPrasadamDetails.city || "");
    formDataToSend.append(
      "pincode",
      formData.mahaPrasadamDetails.pincode || ""
    );

    //try {
    //   const response = await fetch(
    //     "https://script.google.com/macros/s/AKfycbwC1GYzmhRiDqg_6ftg4gEK_eKS0xyICnZvn-juqZqe4RNmKW6iIMoK3akgNymcLKhh/exec",
    //     {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/x-www-form-urlencoded",
    //       },
    //       body: formDataToSend.toString(),
    //     }
    //   );

    //   if (!response.ok) {
    //     throw new Error("Network response was not ok");
    //   }

    //   console.log("Data stored successfully in Google Sheets");
    //   return true;
    // } catch (error) {
    //   console.error("Error storing data:", error);
    //   alert(
    //     "An error occurred while storing your donation details. Please try again."
    //   );
    //   return false;
    // }
  };

  // Load RazorPay script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return (
    <div className="JForm">
      {/* Donation Form - Right Side */}
      <div className=" xl:flex xl:justify-center mb-8 md:mt-4 mt-8 ">
        <div className="donationDetail bg-[#C61D21] py-10 px-2 rounded-3xl xl:h-full xl:p-8 xl:max-w-[800px] w-full">
          <form onSubmit={handleSubmit} className="text-white">
            <h2 className="text-center text-2xl xl:text-4xl">
              Donation Details
            </h2>

            <div className="innerForm sevaContainer">
              {/* tulsiarchana */}
              <label className="block mt-3">
                <input
                  type="checkbox"
                  name="tulsiarchanaSeva"
                  checked={formData.tulsiarchanaSeva}
                  onChange={handleInputChange}
                  style={{ accentColor: "blue" }}
                />
                TULSI ARCHANA SEVA
              </label>

              {formData.tulsiarchanaSeva && (
                <div className="grid grid-cols-2 gap-2 mt-0 ml-4">
                  {[
                    { text: "₹ 2500/-", amount: 2500 },
                    { text: "₹ 1500/-", amount: 1500 },
                    { text: "₹ 1000/-", amount: 1000 },
                    { text: "₹ 500/-", amount: 500 },
                  ].map((item) => (
                    <button
                      className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                      type="button"
                      key={`tulsiarchana-${item.amount}`}
                      onClick={() =>
                        handleAmountSelect("tulsiarchana", item.amount)
                      }
                      style={{
                        backgroundColor:
                          formData.selectedtulsiarchanaAmount === item.amount
                            ? "#fac785"
                            : "",
                      }}
                    >
                      {item.text}
                    </button>
                  ))}
                  <input
                    type="number"
                    name="customtulsiarchanaAmount"
                    placeholder="₹ Donate as you wish"
                    value={formData.customtulsiarchanaAmount || ""}
                    onChange={handleInputChange}
                    className="col-span-2 p-3 border rounded-xl my-1 mx-1 text-black"
                  />
                </div>
              )}
              {/*  Vaikuntha Dwara Puja Seva */}
              <label>
                <input
                  type="checkbox"
                  name="vaikunthaDwaraPujaSeva"
                  checked={formData.vaikunthaDwaraPujaSeva}
                  onChange={handleInputChange}
                  style={{ accentColor: "blue" }}
                />
                VAIKUNTHA DWARA PUJA SEVA
              </label>
              {formData.vaikunthaDwaraPujaSeva && (
                <div className="grid grid-cols-2 -mt-4">
                  {[
                    { text: "₹ 2500/-", amount: 2500 },
                    { text: "₹ 1500/-", amount: 1500 },
                    { text: "₹ 1000/-", amount: 1000 },
                    { text: "₹ 500/-", amount: 500 },
                  ].map((item) => (
                    <button
                      className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                      type="button"
                      key={`vaikunthaDwaraPuja-${item.amount}`}
                      onClick={() =>
                        handleAmountSelect("vaikunthaDwaraPuja", item.amount)
                      }
                      style={{
                        backgroundColor:
                          formData.selectedvaikunthaDwaraPujaAmount ===
                          item.amount
                            ? "#fac785"
                            : "",
                        margin: "5px",
                      }}
                    >
                      {item.text}
                    </button>
                  ))}
                  <input
                    type="number"
                    name="customvaikunthaDwaraPujaAmount"
                    placeholder="₹ Donate as you wish"
                    value={formData.customvaikunthaDwaraPujaAmount || ""}
                    onChange={handleInputChange}
                    className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                  />
                </div>
              )}
              {/* LADDU PRASADA SEVA */}
              <label>
                <input
                  type="checkbox"
                  name="ladduprasadaSeva"
                  checked={formData.ladduprasadaSeva}
                  onChange={handleInputChange}
                  style={{ accentColor: "blue" }}
                />
                LADDU PRASADA SEVA
              </label>
              {formData.ladduprasadaSeva && (
                <div className="grid grid-cols-2 -mt-4">
                  {[
                    { text: "₹ 2500/-", amount: 2500 },
                    { text: "₹ 1500/-", amount: 1500 },
                    { text: "₹ 1000/-", amount: 1000 },
                    { text: "₹ 500/-", amount: 500 },
                  ].map((item) => (
                    <button
                      className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                      type="button"
                      key={`ladduprasada-${item.amount}`}
                      onClick={() =>
                        handleAmountSelect("ladduprasada", item.amount)
                      }
                      style={{
                        backgroundColor:
                          formData.selectedladduprasadaAmount === item.amount
                            ? "#fac785"
                            : "",
                        margin: "5px",
                      }}
                    >
                      {item.text}
                    </button>
                  ))}
                  <input
                    type="number"
                    name="customladduprasadaAmount"
                    placeholder="₹ Donate as you wish"
                    value={formData.customladduprasadaAmount || ""}
                    onChange={handleInputChange}
                    className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                  />
                </div>
              )}
              {/* ANNA DAAN SEVA */}
              <label className="block">
                <input
                  type="checkbox"
                  name="annadaanSeva"
                  checked={formData.annadaanSeva}
                  onChange={handleInputChange}
                  style={{ accentColor: "blue" }}
                />
                ANNDAAN SEVA
              </label>

              {formData.annadaanSeva && (
                <div className="grid grid-cols-2 gap-2 mt-0 ml-4">
                  {[
                    { text: "₹ 2500/-", amount: 2500 },
                    { text: "₹ 1500/-", amount: 1500 },
                    { text: "₹ 1000/-", amount: 1000 },
                    { text: "₹ 500/-", amount: 500 },
                  ].map((item) => (
                    <button
                      className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                      type="button"
                      key={`annadaan-${item.amount}`}
                      onClick={() =>
                        handleAmountSelect("annadaan", item.amount)
                      }
                      style={{
                        backgroundColor:
                          formData.selectedAnnadaanAmount === item.amount
                            ? "#fac785"
                            : "",
                      }}
                    >
                      {item.text}
                    </button>
                  ))}
                  <input
                    type="number"
                    name="customAnnadaanAmount"
                    placeholder="₹ Donate as you wish"
                    value={formData.customAnnadaanAmount || ""}
                    onChange={handleInputChange}
                    className="col-span-2 p-3 border rounded-xl my-1 mx-1 text-black"
                  />
                </div>
              )}

              {/* VASTRA ALANKAR SEVA */}
              <label>
                <input
                  type="checkbox"
                  name="vastraAlankarSeva"
                  checked={formData.vastraAlankarSeva}
                  onChange={handleInputChange}
                  style={{ accentColor: "blue" }}
                />
                VASTRA ALANKAR SEVA
              </label>
              {formData.vastraAlankarSeva && (
                <div className="grid grid-cols-2 -mt-4">
                  {[
                    { text: "₹ 2500/-", amount: 2500 },
                    { text: "₹ 1500/-", amount: 1500 },
                    { text: "₹ 1000/-", amount: 1000 },
                    { text: "₹ 500/-", amount: 500 },
                  ].map((item) => (
                    <button
                      className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-gray-600"
                      type="button"
                      key={`vastraAlankar-${item.amount}`}
                      onClick={() =>
                        handleAmountSelect("vastraAlankar", item.amount)
                      }
                      style={{
                        backgroundColor:
                          formData.selectedvastraAlankarAmount === item.amount
                            ? "#fac785"
                            : "",
                        margin: "5px",
                      }}
                    >
                      {item.text}
                    </button>
                  ))}
                  <input
                    type="number"
                    name="customvastraAlankarAmount"
                    placeholder="₹ Donate as you wish"
                    value={formData.customvastraAlankarAmount || ""}
                    onChange={handleInputChange}
                    className="col-span-2 p-3 border rounded-xl my-1 mx-1 customAmount text-black"
                  />
                </div>
              )}

              <label>
                <input
                  type="checkbox"
                  name="donateByWish"
                  checked={formData.donateByWish}
                  onChange={handleInputChange}
                  style={{ accentColor: "blue" }}
                />
                Donate as you wish
              </label>
              {formData.donateByWish && (
                <div>
                  <input
                    type="number"
                    name="customDonationAmount"
                    placeholder="₹ Donate by your wish"
                    value={formData.customDonationAmount || ""}
                    onChange={handleInputChange}
                    className="w-full p-3 border rounded-xl my-1 text-black"
                  />
                </div>
              )}
            </div>

            <div className="innerForm">
              <h3 className="text-center">Personal Details</h3>
              <label className="xl:w-full">
                <input
                  type="text"
                  name="donorName"
                  value={formData.donorName}
                  onChange={handleInputChange}
                  placeholder="Donor Name"
                  className="mt-2"
                />
                {errors.donorName && (
                  <span className="block -mt-2 ml-2">{errors.donorName}</span>
                )}
              </label>
              <label className="xl:w-full">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Email ID"
                />
                {errors.email && (
                  <span className="block -mt-2 ml-2">{errors.email}</span>
                )}
              </label>
              <div className="flex gap-2">
                <label className="flex-1">
                  <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    placeholder="Mobile Number"
                    className="text-[#909192] p-2 border rounded-md w-full"
                  />
                  {errors.mobile && (
                    <span className="block -mt-2 ml-2">{errors.mobile}</span>
                  )}
                </label>
                <label className="flex-1">
                  <input
                    type="text"
                    name="dob"
                    value={formData.dob}
                    onChange={handleInputChange}
                    className="text-[#909192] p-2 border rounded-md"
                    placeholder="Date Of Birth"
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => (e.target.type = "text")}
                  />
                  {errors.dob && (
                    <span className="block -mt-2 ml-2">{errors.dob}</span>
                  )}
                </label>
              </div>
            </div>
            <p className="text-white mt-2 text-[10px]">
              (Sankalpa and Archana will be performed for you on your birthday)
            </p>

            <p className="text-white -mt-2 text-xs">
              By continuing, you are agreeing to{" "}
              <a className="underline text-[#EEF9A3]">
                Terms of Use and Privacy Policy
              </a>
            </p>

            <div className="px-3 tandd mt-8">
              <label>
                <input
                  type="checkbox"
                  name="receive80G"
                  checked={formData.receive80G}
                  onChange={handle80GCheckboxChange}
                  style={{ accentColor: "blue" }}
                />
                I would like to receive 80(G) Certificate
              </label>
              {show80GDetails && (
                <div className="mb-3">
                  <p className="text-white text-[10px] text-left ml-2">
                    Finance Act 2021 mandates uploading donation details for
                    80(G) deductions. Ensure PAN and address details are
                    provided.
                  </p>
                  <input
                    type="text"
                    name="panNumber"
                    value={formData.panNumber}
                    onChange={handleInputChange}
                    placeholder="Pan Number *"
                    className="w-full bg-white text-black px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400"
                    required
                  />
                  <input
                    type="text"
                    name="doorNumber"
                    placeholder="Door Number"
                    className="text-black"
                    value={formData.mahaPrasadamDetails.doorNumber}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          doorNumber: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="houseName"
                    placeholder="House / Apartment / Building Name"
                    value={formData.mahaPrasadamDetails.houseName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          houseName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="streetName"
                    placeholder="Street Name"
                    value={formData.mahaPrasadamDetails.streetName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          streetName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="area"
                    placeholder="Location / Area"
                    value={formData.mahaPrasadamDetails.area}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          area: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="country"
                    placeholder="Country"
                    value={formData.mahaPrasadamDetails.country}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          country: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="state"
                    placeholder="State"
                    value={formData.mahaPrasadamDetails.state}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          state: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="city"
                    placeholder="City"
                    value={formData.mahaPrasadamDetails.city}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          city: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="pincode"
                    placeholder="Pincode"
                    value={formData.mahaPrasadamDetails.pincode}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          pincode: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
              )}

              <label>
                <input
                  type="checkbox"
                  name="receiveMahaPrasadam"
                  checked={formData.receiveMahaPrasadam}
                  onChange={handleMahaPrasadamCheckboxChange}
                  style={{ accentColor: "blue" }}
                />
                I would like to receive Maha prasadam (Only within India)
              </label>
              {showMahaPrasadamDetails && (
                <div className="mt-3">
                  <input
                    type="text"
                    name="doorNumber"
                    placeholder="Door Number"
                    className="text-black"
                    value={formData.mahaPrasadamDetails.doorNumber}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          doorNumber: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="houseName"
                    placeholder="House / Apartment / Building Name"
                    value={formData.mahaPrasadamDetails.houseName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          houseName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="streetName"
                    placeholder="Street Name"
                    value={formData.mahaPrasadamDetails.streetName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          streetName: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="area"
                    placeholder="Location / Area"
                    value={formData.mahaPrasadamDetails.area}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          area: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="country"
                    placeholder="Country"
                    value={formData.mahaPrasadamDetails.country}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          country: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="state"
                    placeholder="State"
                    value={formData.mahaPrasadamDetails.state}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          state: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="city"
                    placeholder="City"
                    value={formData.mahaPrasadamDetails.city}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          city: e.target.value,
                        },
                      }))
                    }
                  />
                  <input
                    type="text"
                    className="text-black"
                    name="pincode"
                    placeholder="Pincode"
                    value={formData.mahaPrasadamDetails.pincode}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mahaPrasadamDetails: {
                          ...prev.mahaPrasadamDetails,
                          pincode: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
              )}
            </div>

            <div className="flex justify-center mt-8">
              <button
                type="submit"
                className="bg-[#FAE29C] text-black px-12 py-3 rounded-2xl font-bold"
              >
                Donate{" "}
                {getTotalAmount() > 0
                  ? "₹ " + getTotalAmount().toLocaleString("en-IN")
                  : ""}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DonationForm;
